<script setup>
  import DataContainer from '@/components/DataContainer.vue';
  import DataContainerSection from '@/components/DataContainerSection.vue';
  import AlertRow from '@/components/AlertRow.vue';
  import { useGoogleAnalyticsStore } from '@/stores/GoogleAnalyticsStore';

  const googleAnalyticsStore = useGoogleAnalyticsStore();

  const props = defineProps({
    spotName: {
      type: String,
      required: true,
    },
    alerts: {
      type: Array,
      required: true,
    },
    togglingAlerts: {
      type: Object,
      required: true,
    },
  });

  const emits = defineEmits(['addAlert', 'editAlert', 'deleteAlert', 'toggleAlert']);

  const handleAddLocationAlert = () => {
    googleAnalyticsStore.sendEvent('Wind_Alert_Add_To_Location_Click');

    emits('addAlert', props.alerts[0]?.spot_id, props.spotName);
  }
</script>

<template>
  <DataContainerSection :sectionOverflow="false">
    <template #title>{{ spotName }}</template>
    <template #metaActions>
      <button
        type="button"
        class="jwx-button jwx-button--pill jwx-button--small"
        @click="handleAddLocationAlert"
      >
        + Add Location Alert
      </button>
    </template>
    <template #content>
      <DataContainer :padding="false">
        <div class="jwx-data-container__content jwx-overflow-visible" data-surface="1">
          <AlertRow
            v-for="alert in alerts"
            :key="alert.id"
            :alert="alert"
            :isToggling="togglingAlerts.has(alert.id)"
            @edit="emits('editAlert', $event)"
            @delete="emits('deleteAlert', $event)"
            @toggle="emits('toggleAlert', $event)"
          />
        </div>
      </DataContainer>
    </template>
  </DataContainerSection>
</template>
